export default __webpack_public_path__ + "static/SectionTwo_01_01-af94462dea354063d26a09febc4b1da5.png";